<template>
  <div v-outside-click="hideContextMenu" style="position: relative">
    <sub-context :data="data" :depth="0" @hide-subcontext-menu="hideContextMenu" />
  </div>
</template>

<script>
import hotkeys from "hotkeys-js";
import { HotkeyScopes } from "../../../../utils/constants";
import { TeamTypes, icons } from "../../../../utils/icons";
import SubContext from "../SubContext.vue";
export default {
  components: {
    SubContext,
  },
  // authUser must be sent as prop because it doesn't work in computed
  props: ["item", "authUser"],
  data() {
    return {
      index: -1,
      data: [
        {
          id: 2,
          icon: `${icons.Plus}`,
          title: this.$t("contextMenu.newMember"),
          shortcut: `${icons.Plus}`,
          shortcutType: "icon",
          func: this.showMemberDialog,
          hide: this.item.type !== TeamTypes.Team,
        },
        {
          id: 3,
          icon: `${icons.Edit}`,
          title: this.item.type === TeamTypes.Team ? this.$t("contextMenu.edit") : this.$t("contextMenu.changeRole"),
          shortcut: "/",
          func: this.edit,
          hide: this.item.type === TeamTypes.Owner,
        },
        {
          id: 7,
          icon: `${icons.Maximize}`,
          title: this.$t("contextMenu.expandCollapse"),
          shortcut: "Space",
          func: this.toggleExpanded,
          hide: this.item.type !== TeamTypes.Team,
        },
        {
          id: 6,
          icon: `${icons.Trash}`,
          title: this.$t("contextMenu.delete"),
          func: this.removeTeamMember,
          shortcut: "-",
          hide: this.item.type === TeamTypes.Team,
        },
        {
          id: 8,
          icon: `${icons.Trash}`,
          title: this.$t("contextMenu.deleteTeam"),
          func: this.removeTeam,
          shortcut: "",
          hide: this.item.type !== TeamTypes.Team, // Only show for teams
        },
        {
          id: 9,
          icon: `${icons.Mail}`,
          title: this.$t("contextMenu.sendMail"),
          func: this.sendMail,
          shortcut: "m",
          hide: this.item.email === this.authUser?.email,
        },
        {
          id: 10,
          icon: `${icons.Copy}`,
          title: this.item.type !== TeamTypes.Team ? "Copy Email" : "Copy Team ID",
          func: this.copyDetails,
        },
      ],
    };
  },
  mounted() {
    this.$store.dispatch("setScope", HotkeyScopes.SidebarContextMenu);
  },
  beforeUnmount() {
    this.resetHotkeyScope();
  },
  methods: {
    showMemberDialog(editMode = false) {
      this.$store.dispatch("teams/setAddMemberDialog", { id: this.item.id, show: true, editMode });
    },
    edit() {
      if (this.item.type === TeamTypes.Team)
        return this.$store.dispatch("teams/setActiveItem", { id: this.item.id, editMode: true });
      // Change Role
      this.showMemberDialog(true);
    },
    removeTeamMember() {
      this.$store.dispatch("panel/setDeleteDialog", {
        show: true,
        ids: this.item.id,
        title: this.$t("sidebar.delete.team.title"),
        description: this.$t("sidebar.delete.team.description"),
        itemType: "teams",
        action: (action) => {
          this.$store.dispatch(`teams/remove`, { ids: [this.item.id] });
        },
      });
      this.resetHotkeyScope();
    },
    toggleExpanded() {
      this.$store.dispatch("teams/toggleExpanded", { id: this.item.id });
      this.resetHotkeyScope();
    },
    resetHotkeyScope() {
      this.$store.dispatch("setScope", HotkeyScopes.Sidebar.Teams);
      this.index = -1;
    },
    hideContextMenu() {
      this.$store.dispatch("resetActiveContextMenu");
      this.resetHotkeyScope();
    },
    sendMail() {
      this.$store.dispatch("teams/sendMail", { id: this.item.id });
    },
    copyDetails() {
      const detailsToBeCopied = this.item.type !== TeamTypes.Team ? this.item.email : this.item.id;
      navigator.clipboard
        .writeText(detailsToBeCopied)
        .then(() => {
          this.$store.dispatch("addToast", {
            severity: "success",
            life: 3000,
            summary: "Text copied to clipboard",
          });
        })
        .catch((error) => {
          this.$store.dispatch("addToast", {
            severity: "error",
            life: 3000,
            summary: "Failed to copy text",
            detail: "Please try to copy contents of a cell",
          });
          console.log(error);
        });
      this.hideContextMenu();
    },
    removeTeam() {
      if (this.item.childrenCount > 1) {
        this.$store.dispatch("addToast", {
          severity: "warn",
          life: 3000,
          summary: this.$t("sidebar.delete.team.warn"),
          detail: this.$t("sidebar.delete.team.multipleMembers"),
        });
        return;
      }

      this.$store.dispatch("panel/setDeleteDialog", {
        show: true,
        ids: this.item.id,
        title: this.$t("sidebar.delete.team.titleTeam"),
        description: this.$t("sidebar.delete.team.descriptionTeam"),
        itemType: "teams",
        action: () => {
          this.$store.dispatch(`teams/removeTeam`, { id: this.item.id });
        },
      });
      this.resetHotkeyScope();
    },
  },
};
</script>
